export const downloadCSV = (filename, rows) => {
  if (!rows || rows.length === 0) return;

  const header = Object.keys(rows[0]).join(",");
  const csvContent = [
    header,
    ...rows.map((r) => Object.values(r).join(",")),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};